const angular = require('angular');
const moment = require('moment');
var app = angular.module('learn-controllers');

/**
 * Edit Events Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the Analyze resource
 * @argument {Events} Events injected to gain access to the Events resource
 */
app.controller('editEvent', ['Application', 'Authorization', 'Events', 'Analyze', '$scope', '$translate', '$filter', function (Application, Authorization, Events, Analyze, $scope, $translate, $filter) {
  var self = this;
  self.authtoken = Authorization.getAuthToken();
  self.user = self.authtoken.user;
  self.editSaved = true;
  self.backLocation = Application.navigation.history[Application.navigation.history.length - 2];
  self.denied = false;

  var locationChange = $scope.$on('$locationChangeStart', function(event) {
    if (self.editSaved) {
      // Allow the route change to progress
      self.denied = true;
      return;
    }

    // Halt the route change and question the action
    self.navigationPath = {};
    self.navigationPath.targetPath = Application.navigation.getPath();
    self.navigationPath.targetSearch = Application.navigation.getUrlParameters();
    self.navigationPath.targetHash = Application.navigation.getHash();
    event.preventDefault();
    self.showDeparture = true;
    self.onLocationChange = function() {
      locationChange();
    };
  });
  var routeParameters = Application.navigation.getRouteParameters();

  self.newEvent = routeParameters.id === 'new' || !routeParameters.id;

  var evnt = {};
  evnt.type = 'event';
  evnt.tags = [];
  evnt.linked_category = [];
  evnt.related_events = [];
  evnt.max_attendees = 0;
  evnt.max_wait = 0;
  evnt.pre_content = {
    links: []
  };
  evnt.hosts = [{
    name: '',
    image: '',
    bio: ''
  }];
  self.activeTab = 'details';

  self.mediumOpts = {
    'targetBlank': true,
    'toolbar': {
      'buttons': ['bold', 'italic', 'underline', 'anchor', 'h1', 'h2', 'h3', 'quote', 'unorderedlist', 'orderedlist']
    }
  };

  self.navigationDirectory = {
    'details': {
      next: 'images',
      previous: null,
      required: ['title', 'description', 'start_date', 'end_date']
    },
    'images': {
      next: 'categories',
      previous: 'details',
      required: null
    },
    'categories': {
      next: 'supplemental',
      previous: 'images',
      required: null
    },
    'supplemental': {
      next: 'settings',
      previous: 'categories',
      required: null
    },
    'settings': {
      next: 'preview',
      previous: 'supplemental',
      required: null
    },
    'preview': {
      next: null,
      previous: 'settings',
      required: null
    }
  };

  self.nextSection = function(item) {
    var nextClicked = item ? false : true;
    var item = item ? self.navigationDirectory[item].previous : self.activeTab;
    var next = self.navigationDirectory[item].next;
    var missing = '';
    var allow = true;

    var findIssues = function(check) {
      var current = self.navigationDirectory[check];
      if (current.required) {
        for (var i = 0; i < current.required.length; i++) {
          if (!self.evnt[current.required[i]]) {
            allow = false;
            missing = missing + ' ' + current.required[i] + ',';
          }
        }
      }
      // Uncomment befor final commit (checks for required host name)
      if (self.evnt.hosts && self.evnt.hosts[0] && !self.evnt.hosts[0].name) {
        allow = false;
        missing = missing + ' host name,';
      }
      if (current.previous) {
        findIssues(current.previous);
      }
    };

    findIssues(item);

    if (allow && next) {
      if (self.newEvent || !nextClicked) {
        self.activeTab = next;
        Application.scrollTop();
        return;
      }
      self.saveProgress('next')
      .then(function() {
        self.activeTab = next;
        Application.scrollTop();
      });
    }

    if (missing) {
      Application.messaging.addMessage({type: 'error', text: self.translations['edit.general.notification_fieldsMissing'] + missing.slice(0, -1) + '.', duration: 5});
    }
  };

  self.choosePrivacy = function(type) {
    if (type === 'public') {
      self.evnt.public = true;
      self.evnt.invite_only = false;
      self.isPrivate = false;
      return;
    }
    if (type === 'private') {
      self.evnt.public = false;
      self.evnt.invite_only = true;
      self.isPublic = false;
      return;
    }
  };

  self.saveProgress = function(next) {
    if (!self.evnt._id) {
      return;
    }

    // Must delete wait_list and attendees as they could change in user views while updateing
    var saveEvnt = JSON.parse(JSON.stringify(self.evnt));
    delete saveEvnt.attendees;
    delete saveEvnt.wait_list;

    self.updateIndicator = true;
    return Events.update({
      subresource: self.evnt._id,
      fields: 'user,title,hosts,category,linked_category,description,image,banner_image,tags,start_date,end_date,location,online_location,online,explore_hide,mandatory,public,invite_only,max_attendees,attendees,allow_wait,max_wait,instructors,related_events,pre_content,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,private,cover_justification,featured_justification'
    }, saveEvnt).$promise.then(function(evnt) {
      Analyze.record({resource: 'modifications'}, {document: evnt._id, type: 'event'});
      Application.analyticsProvider.trackEvent('event_updated', {content: evnt._id, content_type: 'event', title: evnt.title});
      evnt.attendees = self.evnt.attendees;
      evnt.wait_list = self.evnt.wait_list;
      self.updateIndicator = false;
      Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.event_savedPt1'] + ' ' + $filter('limitTo')(self.evnt.title, 25) + (self.evnt.title.length > 25 ? '[...]' : '') + ' ' + self.translations['modules.notifications.event_savedPt2'], duration: 5});
      self.editSaved = true;
    }).catch(function(err) {
      console.log('Error in update: ', err);
    });
  };

  self.createEvent = function() {
    if (!self.newEvent || self.evnt._id) {
      return;
    }

    self.updateIndicator = true;
    if (self.newEvent) {
      self.evnt.user = self.user._id;
    }
    self.evnt.summary = self.evnt.content;

    Events.create(self.evnt).$promise
    .then(function(evnt) {
      Analyze.record({resource: 'creations'}, {document: evnt._id, type: 'event'});
      Application.analyticsProvider.trackEvent('event_created', {content: evnt._id, content_type: 'event', title: evnt.title});
      self.updateIndicator = false;
      Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.event_createdPt1'] + ' ' + self.evnt.title + ' ' + self.translations['modules.notifications.event_createdPt2'], duration: 5});
      self.editSaved = true;
      Application.navigation.goTo('/view/events/' + evnt._id);
    }).catch(function(err) {
      console.log('Error in update: ', err);
    });
  };

  self.removeEvent = function() {
    self.updateIndicator = true;
    Events.remove({subresource: self.evnt._id}).$promise
    .then(function(evnt) {
      Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.event_removed'], duration: 5});
      self.editSaved = true;
      self.showDelete = false;
      Analyze.record({resource: 'deletions'}, {document: self.evnt._id, type: 'event'});
      Application.analyticsProvider.trackEvent('event_deleted', {content: self.evnt._id, content_type: 'event', title: self.evnt.title});
      Application.navigation.goTo('/overview/events');
      self.updateIndicator = false;
    }).catch(function(err) {
      console.log('Error in update: ', err);
    });
  };

  self.addImage = function(link) {
    self.evnt.hosts[0].image = link;
  };

  self.setWatches = function() {
    var combineTimes = function() {
      if (!self.evnt.startDate || !self.evnt.startTime || !self.evnt.endDate || !self.evnt.endTime) {
        return;
      }
      // Combine the start and end dates and times to create coherent dates to store in the event
      var momentStartTime = moment(self.evnt.startTime.toISOString());
      var momentEndTime = moment(self.evnt.endTime.toISOString());
      var combStart = moment(new Date(self.evnt.startDate).toISOString()).hours(momentStartTime.hours()).minutes(momentStartTime.minutes()).seconds(0).milliseconds(0);
      var combEnd = moment(new Date(self.evnt.endDate).toISOString()).hours(momentEndTime.hours()).minutes(momentEndTime.minutes()).seconds(0).milliseconds(0);
      self.evnt.start_date = new Date(combStart.toISOString());
      self.evnt.end_date = new Date(combEnd.toISOString());
    };
    var timeChanged = function(terminus, datetime) {
      var stMoment = moment(self.evnt.startTime.toISOString());
      var etMoment = moment(self.evnt.endTime.toISOString());

      if (!self.evnt.startDate || !self.evnt.endDate || !self.evnt.startTime || !self.evnt.endTime) {
        self.setTimes();
      }

      if (datetime === 'date' && moment(self.evnt.startDate, 'MM/DD/YY') > moment(self.evnt.endDate, 'MM/DD/YY')) {
        if (terminus === 'start') {
          self.evnt.endDate = self.evnt.startDate.slice(0);
        }
        if (terminus === 'end') {
          self.evnt.startDate = self.evnt.endDate.slice(0);
        }
        combineTimes();
        return;
      }
      if (datetime === 'time') {
        var stValue = stMoment.hours() + stMoment.minutes();
        var etValue = etMoment.hours() + etMoment.minutes();

        if (self.evnt.startDate === self.evnt.endDate && stValue > etValue) {
          if (terminus === 'start') {
            if (stMoment.hours() === 23) {
              self.evnt.endDate = moment(new Date(self.evnt.startDate).toISOString()).add(1, 'days').format('MM/DD/YY');
            }
            var newEnd = moment(self.evnt.startTime).add(1, 'hours').seconds(0).milliseconds(0);
            self.evnt.endTime = new Date(newEnd.toISOString());
          }
          if (terminus === 'end') {
            if (etMoment.hours() === 0) {
              self.evnt.startDate = moment(new Date(self.evnt.endDate).toISOString()).subtract(1, 'days').format('MM/DD/YY');
            }
            var newStart = moment(self.evnt.endTime).subtract(1, 'hours').seconds(0).milliseconds(0);
            self.evnt.startTime = new Date(newStart.toISOString());
          }
        }
      }
      combineTimes();
    };

    // Set watches for all calendar inputs
    var watchDatetimeItems = ['editor.evnt.startDate', 'editor.evnt.startTime', 'editor.evnt.endDate', 'editor.evnt.endTime'];
    for (var i = 0; i < watchDatetimeItems.length; i++) {
      (function() {
        var terminus = new RegExp('start').test(watchDatetimeItems[i]) ? 'start' : 'end';
        var datetime = new RegExp('Time').test(watchDatetimeItems[i]) ? 'time' : 'date';
        $scope.$watch(watchDatetimeItems[i], function(newVal, oldVal) {
          if (newVal === oldVal) {
            return;
          }
          timeChanged(terminus, datetime);
        });
      })();
    }
  };

  self.setTimes = function() {
    var now;
    var startTime;
    var endTime;
    // If its a new event, create a new date for the start time and the end time 1 hour later
    if (!self.evnt.start_date || !self.evnt.end_date) {
      now = moment().seconds(0).milliseconds(0);
      startTime = moment().hours(now.minutes() < 30 ? now.hours() : now.hours() + 1).minutes(now.minutes() < 30 ? 30 : 0).seconds(0).milliseconds(0);
      endTime = moment().hours(startTime.hours() + 1).minutes(startTime.minutes()).seconds(0).milliseconds(0);
    }

    // If the evnt has start and end dates already use them to extract the start dates and times
    if (self.evnt.start_date && self.evnt.end_date) {
      startTime = moment(new Date(self.evnt.start_date).toISOString()).seconds(0).milliseconds(0);
      endTime = moment(new Date(self.evnt.end_date).toISOString()).seconds(0).milliseconds(0);
    }
    if (!startTime || !endTime) {
      return;
    }

    self.evnt.startDate = startTime.format('MM/DD/YY');
    self.evnt.endDate = endTime.format('MM/DD/YY');
    self.evnt.startTime = new Date(startTime.toISOString());
    self.evnt.endTime = new Date(endTime.toISOString());
  };

  self.goBack = function() {
    if (!self.denied || !self.backLocation) {
      Application.navigation.back();
      self.denied = true;
      return;
    }
    self.denied = true;
    var location = self.backLocation.split('/#/');
    if (location.length !== 2) {
      Application.navigation.back();
      return;
    }
    Application.navigation.goTo(location[1]);
  };

  self.initialize = function () {
    if (!Authorization.hasValidAuthToken()) {
      if (Application.navigation.isRouteSecure()){
        Application.navigation.goToSignIn();
      }
    }

    if (self.newEvent) {
      self.evnt = evnt;
      self.setTimes();
      self.setWatches();
      self.choosePrivacy('public');
      self.isPublic = true;
      self.isPrivate = false;
      self.startEditWatch();
      return;
    }

    Events.get({
      subresource: routeParameters.id,
      fields: 'user,title,hosts,category,linked_category,description,image,banner_image,tags,start_date,end_date,location,online_location,online,explore_hide,mandatory,public,invite_only,max_attendees,attendees,allow_wait,max_wait,instructors,related_events,pre_content,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,private,cover_justification,featured_justification'
    }, function (data) {
      self.evnt = data;
      self.setTimes();
      self.setWatches();
      self.startEditWatch();
      if (self.invite_only) {
        self.choosePrivacy('private');
        self.isPublic = false;
        self.isPrivate = true;
        return;
      }
      self.choosePrivacy('public');
      self.isPublic = true;
      self.isPrivate = false;
    }, function (error) {
      Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.unableToFindEvent'], duration: 5});
    });
  };

  self.startEditWatch = function() {
    $scope.$watch('editor.evnt', function(newVal, oldVal) {
      if (!newVal || newVal === oldVal) {
        return;
      }
      self.editSaved = false;
    }, true);
  };

  $translate(['edit.general.notification_fieldsMissing', 'edit.general.notification_titleMissing', 'edit.general.notification_confirmLeave', 'modules.notifications.event_createdPt1', 'modules.notifications.event_createdPt2', 'modules.notifications.event_savedPt1', 'modules.notifications.event_savedPt2', 'modules.notifications.event_removed', 'modules.notifications.unableToFindEvent']).then(function(translations){
    self.translations = translations;
    self.initialize();
  });
}]);
